export default __webpack_public_path__ + "static/media/LAS0220.34I-30562_-23980_0.97615f2b.jpg";